import React, { useState } from "react";
import "./qualification.css";

const Qualification = () => {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className="qualification section">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My personal journey</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div
            className={
              toggleState === 1
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={() => toggleTab(1)}
          >
            <i className="uil uil-graduation-cap qualification__icon"></i>
            Education
          </div>

          <div
            className={
              toggleState === 2
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={() => toggleTab(2)}
          >
            <i className="uil uil-briefcase-alt qualification__icon"></i>
            Experience
          </div>
        </div>

        <div className="qualification__sections">
          <div
            className={
              toggleState === 1
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Bragança Technological Institute - ESTIG</h3>
                <span className="qualification__subtitle">
                  Portugal - Institute
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2018 - 2023
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
              </div>

              <div>
                <h3 className="qualification__title">High School Santa Maria Maior</h3>
                <span className="qualification__subtitle">
                  Portugal - High School
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2015 - 2017
                </div>
              </div>
            </div>         
          </div>

          <div
            className={
              toggleState === 2
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >

            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

               <div>
                <h3 className="qualification__title">IT Support Specialist</h3>
                <span className="qualification__subtitle">
                  Sofynetech
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 09/2024 - Current
                </div>
              </div> 
            </div>

            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Freelancer</h3>
                <span className="qualification__subtitle"> -</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2023 - Current
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

               <div>
                <h3 className="qualification__title">Frontend Developer</h3>
                <span className="qualification__subtitle">
                  Horus Software
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 01/2024 - 03/2024
                </div>
              </div> 
            </div>

            {/* New Experience */}
            <div className="qualification__data">
              
              <div>
                <h3 className="qualification__title">Trainee Programmer</h3>
                <span className="qualification__subtitle">
                  Portugal - InforViana
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2015 - 2017
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Qualification;
